module.exports = new __parcel__URL__("testimonial-wonchul-mobile.82623782.webp").toString();